import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import Textlink from '@xingternal/malt-textlink';

import BlacklistedImage from './../../Components/Illustrations/BlacklistedImage';
import TextLoadingSkeleton from './../../Components/LoadingSkeletons/TextLoadingSkeleton';
import { CustomH, CustomP } from './../../Components/CustomMalt/Typography';

import api from './../../utils/api';

import messages from './messages';
import styles from './Blacklisted.css';

const buildLink = (href, text) => <Textlink href={href}>{text}</Textlink>;

const Blacklisted = ({ intl }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get('/user/deactivated')
      .then(() => setLoading(false))
      .catch(_error => {
        window.location = '/';
      });
  }, []);

  if (loading) {
    return <TextLoadingSkeleton />;
  }

  return (
    <>
      <BlacklistedImage />
      <CustomH>
        <FormattedMessage {...messages.salutation} />
      </CustomH>
      <CustomP>
        <FormattedMessage {...messages.paragraph1} />
      </CustomP>
      <CustomP>
        <FormattedMessage {...messages.paragraph2} />
      </CustomP>
      <CustomP className={styles.emailLink}>
        {buildLink(
          intl.formatMessage(messages.paragraph2linkTarget),
          intl.formatMessage(messages.paragraph2linkText)
        )}
      </CustomP>
      <CustomP>
        <FormattedMessage
          {...messages.paragraph3}
          values={{
            helpCenterLink: buildLink(
              intl.formatMessage(messages.paragraph3linkTarget),
              intl.formatMessage(messages.paragraph3linkText)
            ),
          }}
        />
      </CustomP>
    </>
  );
};

Blacklisted.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Blacklisted);
